import React from 'react';
import { Box, CardMedia, Container, Stack, Typography } from '@mui/material';
import { useDevice } from '../../hooks/useResponsive';
import GradientCTAButton from './InspectionButton';

const BuyarService = () => {
  const { isMobile } = useDevice();

  return (
    <>
      <Container sx={{ pt: 6, pb: 5, px: isMobile ? 2 : 0.8, backgroundColor: 'white' }}>
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/dontRisk.webp"
          alt="Card Image"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px' }}
        />
        <Stack pt={2} pb={3} pr={7} px={1.5}>
          <Typography color="#000000" fontSize={24} fontWeight={800} mb={1} lineHeight={1.2}>
            Don't Risk Your <br />
            Hard-Earned Money!!!
          </Typography>
          <Typography fontSize="11px" color="#000000" fontWeight="400" pr={5}>
            Buying a used car from unknown sellers can be risky—mechanic checks may miss hidden issues, leaving you
            unprotected and unsure.
          </Typography>
          <Box mt={2}>
            <Typography color="#000000" fontSize="11px">
              ❓ Uncertainty about car's real condition
            </Typography>
            <Typography color="#000000" fontSize="11px">
              🔧 Traditional checks miss hidden issues
            </Typography>
            <Typography color="#000000" fontSize="11px">
              😟 Anxious and unprotected purchases
            </Typography>
          </Box>
        </Stack>

        <GradientCTAButton text="Book Your Inspection Now" />
      </Container>
    </>
  );
};

export default BuyarService;
